import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

import {
	PostResendConfirmPhone,
	PostResendConfirmPhoneParams,
	PostResendConfirmPhoneResponse,
} from 'domain/usecases';

export class RemotePostResendConfirmPhone implements PostResendConfirmPhone {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostResendConfirmPhoneResponse>,
	) {}

	async post(params: PostResendConfirmPhoneParams): Promise<PostResendConfirmPhoneResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
